export default __webpack_public_path__ + "static/media/instagramWallChicago.1916c805.png";